import { createContext, useContext } from "react";

const PinActionContext = createContext<{
  holdPinAction?: boolean;
  setHoldPinAction?: (holdPinAction: boolean) => void;
}>({});

export default function PinActionProvider({
  contextValue,
  children,
}: {
  contextValue: {
    holdPinAction?: boolean;
    setHoldPinAction?: (holdPinAction: boolean) => void;
  };
  children: React.ReactNode;
}) {
  return (
    <PinActionContext.Provider value={contextValue}>
      {children}
    </PinActionContext.Provider>
  );
}

export function usePinActionContext() {
  return useContext(PinActionContext);
}
